import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { ITrack } from '../../../../Interface/track'
import { TracksService } from '../../../../services/tracks.service'

@Component({
  selector: 'bmcore-editor-choice',
  templateUrl: './bmcore-editor-choice.component.html',
  styleUrls: ['./bmcore-editor-choice.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreEditorChoiceComponent implements OnInit {
  pageSize = 8
  tracks: ITrack[] = []

  constructor(private tracksService: TracksService) {}

  ngOnInit(): void {
    this.tracksService.getEditorChoiceBeats(this.pageSize).subscribe(res => {
      this.tracks = res.items
    })
  }
}
